import { belongsTo, type AsyncBelongsTo } from '@ember-data/model';
import EmployeeGroupModel from 'garaje/models/employee-group';
import type EmployeeGroupRoleModel from 'garaje/models/employee-group-role';
import adapter from 'garaje/utils/decorators/adapter';

@adapter('v3-coalesce')
class ScimCustomEmployeeGroupModel extends EmployeeGroupModel {
  @belongsTo('employee-group-role', { async: true, inverse: 'employeeGroup', as: 'employee-group' })
  declare employeeGroupRole: AsyncBelongsTo<EmployeeGroupRoleModel>;
}

export default ScimCustomEmployeeGroupModel;

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'scim-custom-employee-group': ScimCustomEmployeeGroupModel;
  }
}
